import React, { useEffect, useState } from 'react';
import { Timeline, Tabs, Spin, Row, Col } from 'antd';
import { useQuery } from 'react-query';
import { SwapOutlined, DownCircleOutlined } from '@ant-design/icons';
import {
  getEntityProcessFollowup,
  ViewProcTaskFollowUpResponse,
} from '../services/workflow';
import { isNil } from 'lodash';
import ProcedureDisplay from './ProcedureDisplay';
import GetLabel from 'DisplayFramework/components/GetLabel';
import ButtonOperation from './ButtonOperation';
const { TabPane } = Tabs;
type ProcessFollowUpProps = {
  entity: string;
  entityid: number;
  entityReference: string;
  refetech?: any;
  refetchProp?: any;
};

const ProcessFollowUp = (props: ProcessFollowUpProps) => {
  const { entity, entityid, entityReference, refetech,refetchProp } = props;
  const {
    data: processData,
    refetch,
    isLoading,
  } = useQuery(
    ['getEntityProcessFollowup', { entity, entityid, refetech, refetchProp }],
    () =>
      getEntityProcessFollowup({ entity: entity, entityid: entityid }).then(
        (res) => SortProcessDataByDateDesc(res.list) || []
      ),
    { enabled: !isNil(entity) }
  );
  const [reverse, setReverse] = useState(false);
  useEffect(() => {
    refetch();
  }, [refetech]);
  const handleClick = () => {
    setReverse(!reverse);
  };

  const [showAll, setshowAll] = useState(false);

  const showMoreAll = () => {
    if (showAll === true) {
      setshowAll(false);
    } else {
      setshowAll(true);
    }
  };

  const SortProcessDataByDateDesc = (
    list: ViewProcTaskFollowUpResponse[]
  ): ViewProcTaskFollowUpResponse[] => {
    return list?.sort(
      (date1: any, date2: any) =>
        new Date(date2.taskstatusdate).getTime() - new Date(date1.taskstatusdate).getTime()
    );
  };

  return (
    <Tabs
      activeKey="1"
      tabBarExtraContent={
        <Row>
          <Col style={{ marginRight: 5 }}>
            <ButtonOperation
              comcode="inverse"
              icon={<SwapOutlined type="primary" rotate={90} />}
              onClick={handleClick}
              disabled={processData?.length === 0 || isNil(processData)}
            />
          </Col>
          <Col>
            <ButtonOperation
              type="primary"
              comcode="showall"
              icon={<DownCircleOutlined />}
              onClick={showMoreAll}
              disabled={processData?.length === 0 || isNil(processData)}
            />
          </Col>
        </Row>
      }
    >
      <TabPane
        tab={<GetLabel label="ProcessFollowUp" />}
        key="1"
        style={{ padding: 30, height: '100%' }}
        active
      >
        {isLoading ? (
          <Row justify="center">
            {' '}
            <Spin />
          </Row>
        ) : processData?.length !== 0 && !isNil(processData) ? (
          <Timeline mode="left" reverse={reverse}>
            {processData?.map(
              (task: ViewProcTaskFollowUpResponse, index: number) => (
                <ProcedureDisplay
                  showAll={showAll}
                  refetch={refetch}
                  task={task}
                  key={index}
                  entityReference={entityReference}
                />
              )
            )}
          </Timeline>
        ) : (
          <Row justify="center">
            <GetLabel style={{ fontSize: 16 }} label="processempty" />
          </Row>
        )}
        {/* <Row justify="end">
          <Col
            style={{
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
            }}
          ></Col>
        </Row> */}
      </TabPane>
    </Tabs>
  );
};

export default ProcessFollowUp;
